import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconAdd = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-add' + (className ? ` ${className}` : '')}
            fill='none'
            height='13'
            viewBox='0 0 13 13'
            width='13'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M6.09649 12.1853C5.95548 12.1853 5.83607 12.1372 5.73826 12.041C5.64031 11.945 5.59134 11.826 5.59134 11.684V6.59392H0.501292C0.35926 6.59392 0.240235 6.54624 0.144218 6.45086C0.0480726 6.35549 0 6.23736 0 6.09649C0 5.95548 0.0480726 5.83607 0.144218 5.73826C0.240235 5.64031 0.35926 5.59134 0.501292 5.59134H5.59134V0.501292C5.59134 0.35926 5.63903 0.240234 5.7344 0.144218C5.82977 0.0480723 5.9479 0 6.08877 0C6.22978 0 6.34919 0.0480723 6.44701 0.144218C6.54495 0.240234 6.59392 0.35926 6.59392 0.501292V5.59134H11.684C11.826 5.59134 11.945 5.63903 12.041 5.7344C12.1372 5.82977 12.1853 5.9479 12.1853 6.08877C12.1853 6.22978 12.1372 6.34919 12.041 6.44701C11.945 6.54495 11.826 6.59392 11.684 6.59392H6.59392V11.684C6.59392 11.826 6.54624 11.945 6.45086 12.041C6.35549 12.1372 6.23736 12.1853 6.09649 12.1853Z'
                fill={fill} />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconAdd;
